<template>
    <div class="experience">
        <!-- 新增样式 -->
        <div v-for="(item, index) in contentList" :key="index" class="content-section">
            <div class="left-section">
                <h2>IN {{ item.year }}</h2>
                <el-image :src="item.imgUrl"  style="width: 200px; height: 250px" alt="Image"></el-image> 
            </div>
            <div class="right-section">
                <!-- 增加了 text-title 类 -->
                <h3 class="text-title">{{ item.title }}</h3>
                <!-- 新增样式 -->
                <p class="content-text left-align">{{ item.content }}</p>
                <!-- 如果item有name属性，则显示name和按钮 -->
                <div v-if="item.name" class="name-button-container">
                    <span>{{ item.name }}</span>
                    <el-button class="custom-button" @click="toInfertilitet">Läs mer</el-button>
                </div>
            </div>
        </div>
        <div class="info-container">
            <div class="info" v-for="(info, index) in contentInfo" :key="index">
                <el-image style="width: 150px; height: 200px" :src="info.imgUrl" />
                <h5>{{ info.text }}</h5>
                <!-- 添加 el-button 并使用新的样式类 -->
                <el-button class="custom-button info-button"  @click="toInfertilitet">Läs mer</el-button>
            </div>
        </div>
        <div class="content-text">
            <div class="content-text_content" v-for="(txt, index) in contentInfo2" :key="index">
                <h4 class="left-align">{{ txt.date }}</h4>
                <p class="left-align" style="color: #2e7d32;">{{ txt.title }}</p>
                <div class="left-align">{{ txt.content }}</div>
                <h4 class="left-align">{{ txt.name }}</h4>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "experienceP",
    data() {
        return {
            contentList: [
                {
                    year: "2024",
                    imgUrl: require("@/assets/experience/timeImg1.jpg"),
                    title: "Tack så mycket!",
                    content: "Jagbesökte kliniken först då jag haft oregelbunden och utebliven menstruation. För att kunna bli gravid, behövdes detta först regleras och åtgärdas. Min kropp reageradd mycket positivt till behandlingarna och inte nog med en regelbunden menstruation så kändes kroppen mer balanserad och mer energisk med dem veckovisa behandlingarna. Jag har haft missfall tidigare men efter att genomgått dessa behandlingar, lyckades jag bli gravid inom några månader på ett naturligt sätt. Under första trimestern och de sista veckorna av graviditeten genomgick jag akupunktur behandling. Och detta var ett väldigt bra fysiskt och mentalt stöd som ledde till att jag alltid kändes mig avslappnad i kroppen. Behandlingarna hjälpte också mot illamåendet och tröttheten första trimestern. Jag kände mig väl omhändertagen och fick stöd som ökade mitt självförtroende för att kunna genomgå denna resan. Dr. Zhou Ying är väldigt omtänksam och lyhörd. Hon förklarar alltid de olika stegen i processen med gott tålamod, vilket fick gjorde mig trygg. Hon är en väldigt erfaren och ställer alltid passande frågor och gav mig goda råd utöver behandlingarna.Jag är väldigt tacksam för den Kinesiska Kliniken och hjälpen jag fått. Kan bara värmt rekommendera ett besök!"
                },
                {
                    year: "2022",
                    imgUrl: require("@/assets/experience/timeImg2.jpg"),
                    title: "Tack så mycket!",
                    name:"Antoinette",
                    content: "Jag hade gjort tre inseminationsförsök men som tyvärr slutat i tårar och ett tidigt missfall. Ying bryr sig verkligen om och finns där för dig hela vägen. 6 veckor efter min första behandling gjorde hon en inför behandling precis innan jag åkte till kliniken för mitt fjärde försök. Kroppen och hela jag kände mig väldigt redo vilket resulterade i att jag den 25 april 2021 fick uppleva de två strecken på graviditetstestet😊 Under min graviditet gickjag på behandlingar för att behålla min bebis och jag mådde väldigt bra hela graviditeten ☺️"
                },
                {
                    year: "2021",
                    imgUrl: require("@/assets/experience/timeImg3.jpg"),
                    title: "Tack så mycket!",
                    content: "Jag hade svårt att somna även om jag var trött. När jag väl somnade så sov hade jag dålig sömnkvalité och jag vaknade två gånger på natten och hade mycket svårt att somna om. Ofta fick jag gå upp då jag var för orolig att ligga kvar i sängen. Detta resulterade i låg energi på dagarna, mycket trött, dåligt humör osv. Efter bara någon behandling hos Ying så kände jag en enorm skillnad, kunde knappt tro det var sant! Jag somnade fort, när jag vaknade somnade jag om i princip direkt igen och kvaliteten på sömnen är oerhört mycket bättre!! Jag mår mycket bättre på dagarna också! Jag ser så framemot varje behandling jag åker till! Man blir så otroligt väl omhändertagen och professionell bemött! Kan inte nog rekommendera Swe Kinesisk Akupunktur Klinik i Malmö! Tusen TACK!! Ann-Maria"
                },
                {
                    year: "2020",
                    imgUrl: require("@/assets/experience/timeImg4.jpg"),
                    title: "Tack så mycket!",
                    name: "Hanna",
                    content: "Jag och min partner fick 3 missfall under det första året som vi försökte få barn. Efter det tredje missfallet kontaktade jag Kinesisk Klinik för att se om akupunktur kunde hjälpa oss att bli gravida och behålla barnet. Jag fick en tre månaders behandling av Ying och hennes man och efter det blev vi gravida igen. Jag fortsatte med akupunktur hos Kinesisk Klinik under större delen av graviditeten och i augusti föddes vår underbara lilla dotter. Jag skulle varmt rekommendera Kinesisk Klinik till alla som har liknande svårigheter med att få barn."
                },
            ],
            contentInfo: [
                {
                    imgUrl: require("@/assets/experience/timeImg5.jpg"),
                    text: "Hjärtligt Tack!!",
                },
                {
                    imgUrl: require("@/assets/experience/timeImg6.jpg"),
                    text: "Jag är den nya bebiset år 2019",
                },
                {
                    imgUrl: require("@/assets/experience/timeImg7.jpg"),
                    text: "Jag är den nya bebiset år 2019",
                },
            ],
            contentInfo2: [
                {
                    date: "MARS 20 , 2023",
                    title: "Utmattningsyndrom",
                    content: "Jag blev utbränd efter mycket stress. Det gav oro, ångest, svårt att sova och många andra problem. Efter att ha kämpat i ca 2 år att försöka bli bättre så föll jag alltid tillbaka till mina utmattningsymptom. Sjukvården gav mig mediciner som hjälpte lite men botade inte mina problem. Efter att jag läst om akupunktur som behandlings alternativ till mina problem så såg jag som sista utväg att boka en tid. Jag hittade Kinesisk klinik och fick träffa Ying som påbörjade min behandling. Jag kunde efter ett fåtal behandlingar känna att något hände som gjorde att jag fick mer energi och vilja. Efter en längre behandlingsperiod kan jag nu förklara mig i princip frisk. Inga mediciner eller annat. Jag var ärligt talat skeptisk men det som hänt mig är helt fantastiskt. Ying gav mig livet tillbaka och jag är evigt tacksam. Jag kan absolut rekommendera andra med liknande problem att prova akupunktur hos Kinesisk klinik.",
                    name: "Anders H"
                },
                {
                    date: "FEBRUARI  14 , 2021",
                    title: "Icke fungerande mage, utbrändhet, stora nackproblem ",
                    content: "Utbrändhet, ingen energi, problem med magen och stel nacke. Har haft problem med krånglande mage i många år, uppblåsthet och svårt att gå på toaletten. Akupunkturen har hjälpt väldigt bra och nu funkar magen igen! Helt otroligt! Är så tacksam! Efter mer än ett års sjukskrivning pga utbrändhet och ingen energi/obalans i hormonerna så känner jag (efter bara några veckors behandling) äntligen en stor skillnad på min ork och fokuseringsförmåga! Är piggare, orkar mycket mer, orkar gå promenader, kan fokusera och hålla mig koncentrerad mycket längre! Helt magiskt! Min sömn har också blivit lugnare och mer stabil igen (sov oroligt och drömde mycket röriga och intensiva drömmar). Min oerhört stela nacke- som medförde migränliknande symptom- har också blivit mycket bättre! Ni är bara bäst! Tack för allt ni gör och ert fina, omtänksamma och professionella omhändertagande, speciellt under Covid-19, ni gör allt enligt reglerna och mer än det, så hygieniskt och bra! Man kan tryggt komma till er utan känna rädsla för Covid-19!",
                    name: "Anders H"
                },
                {
                    date: "APRIL  27 , 2020",
                    title: "Tusen Tack!!",
                    content: "Jag har haft mycket problem med magsyra under flera månader. När det var som värst var jag tvungen att stiga upp 3-4 gånger under natten för att ta något som skulle neutralisera syra som kom upp i matstruppen och även på tungan. Syradämpande mediciner (som Omeprazol) hjälpte lite men efter flera veckors medicinering blev matsmältningen mycket sämre. Gastroskopi visade att allt var ok och man kunde inte hitta orsak till mina problem. Jag läste om andras erfarenhet att överskott på magsyra och brist på magsyra kan ge exakt samma symptom. Det gjorde mig rädd och osäker på medicinering med Omeprazol. Samtidigt som jag använde Omeprazol började jag med akupunkturbehandling hos Professor Guo och Dr Ying. De lugnade ner mig genom att säga att deras behandling kommer att hjälpa min mage oavsett om det handlar om överskott eller brist på magsyra. Behandlingen pågick drygt ett halvår (en gång/vecka) men nu är min mage helt återställd. Jag rekommenderar varmt den här kliniken för här tar man verkligen hand om patienten på bästa sätt.",
                    name: "Anders H"
                },
                {
                    date: "JULY 25 , 2018",
                    title: "Vårt barn föddes 2019.",
                    content: "Jag har sedan tidig ålder haft fruktansvärda problem med mensvärk, kramper som gjort att jag svimmat och legat totalt däckad i flera timmar. Det har påverkat mitt liv oerhört mycket och jag har otaliga gånger varit tvungen att ta mig hem från jobb, skola, träning och andra tillställningar. Har besökt olika gynekologer genom åren som alla konstaterat att 'inget var fel', fick bara mer och mer smärtstillande utskrivet som ändå inte hjälpte. I samband med att min sambo och jag försökt få barn under en lång period bestämde jag mig för att börja på akupunktur hos Prof.Guo Akupunktur  Klinik. Dels för att få bukt med min mensvärk och dels för att kanske kunna få hjälp med att få barn på naturlig väg (i mitt huvud har jag alltid tänkt att dessa delar hör ihop). Jag fick ett underbart bemötande från första stund och det är ett speciellt lugn som infinner sig när man kliver in genom dörren. Att bli tagen på allvar för sina problem och att någon ser helheten samt faktiskt finner lösningar har varit direkt avgörande för mitt psyke efter alla år med problem. Under den tid jag gått på akupunktur så har inte bara mensvärken blivit bättre, utan jag har även fått mer balans i kroppen och en mer välmående känsla överlag hela månaden.  Och för några veckor sedan så gick drömmen i uppfyllelse.. jag och min sambo väntar äntligen barn💖. Tack vare lyhörd, snäll, kunnig och professionell personal på Prof.Guo Akupunktur Klinik.",
                    name: "Anders H"
                },
                {
                    date: "JUNE 14, 2018",
                    title: "Allergi och Astma",
                    content: "Min son på 13, blev allergisk mot hund efter att vår egen hund gick bort 2013. Sen har han sedan han var liten haft ansträngnings-astma. Han är en aktiv basketspelare men har under stressade situationer ofta fått svårt att få luft, och har därför aldrig lämnat huset utan sin 'Bricanyl'. Redan under sin första behandling var han helt lyrisk. Han beskrev att när han låg där på behandlingsbänken och kände hur han för första gången på länge kunde andas djupt och känna hur han fick 'syra' luft till lungorna. Nu efter 20 behandlingar känner han knappt några problem med andningen och han reagerar inte lika kraftigt på hundar. Det finns även hundar han inte allt känner av. Som mamma, känns det dessutom fantastisk att se hur 'Guo och Ying' de 2 akupunktörer visar en sådan omsorg till min son. Och min son känner stor tilltro till dem och har full tillit till deras kunskapar.",
                    name: "Anders H"
                },
                {
                    date: "JUNE , 2018",
                    title: "Kronisk ryggsmärta i 14 år",
                    content: "Jag genomgick en stor ryggoperation för 14 år sedan, en operation som skulle ta bort min scolios diagnos. Operationen utfördes och metall sattes in i hela ryggraden för att stabilisera så att scoliosen inte skulle förvärras och därmed kväva mina inre organ (steloperation). Efter operationen ficks jag tyvärr kronisk ryggsmärta som inte gick att behandla med något annat än starka mediciner som jag ätlt i 14 år och samtidigt fått höja doserna flertal gånger då smäatan inte gick att hantera. Efter att min mamma började gå Dr. Guo och Dr. Ying med goda resultat, blev jag introducerad hos dem. I drygt 2 år har jag gått hos dem har behandlat mig 2 gånger i veckan då detta var långvarig smärta som de skulle handskas med. Idag, har jad slutat med alla mina mediciner tack vare dem och mitt tålamod. De har gett mig liv tillbaka utan starka mediciner och i skrivande stund är jag dessutom höggravid vilket inte skulle vara en möjlighet med de mediciner jag gick på. Jag har allt att tacka dem för och de mirakel de har utfört hos mig!",
                    name: "Anders H"
                },

            ]
        };
    },
    methods: {
        toInfertilitet() {
            // 携带参数进行路由跳转
            this.$router.push({
                path: '/infertilitet'
            });
        }
    },
}
</script>
<style scoped lang="scss">
.experience {
    min-width: 1200px; // 保持最小宽度;
    width: 1200px; // 允许内容块宽度自适应;
    .content-section {
        display: flex;
        
        margin-bottom: 40px; // 增加底部间距，让内容块之间更清晰
        align-items: flex-start; // 让左右部分在垂直方向上顶部对齐
        background-color: #fff;
        .left-section {
            padding-right: 40px; // 增加右侧间距，让图片和文字之间有更多空间
            width: 250px; // 固定左侧图片区域的宽度

            h2 {
                margin-bottom: 20px; // 增加标题下方的间距
            }

            img {
                width: 200px;
                height: 250px;
                object-fit: cover; // 确保图片填满容器，避免变形
            }
        }

        .right-section {
            margin: auto;
            flex: 1; // 让右侧部分占据剩余空间
            max-width: calc(100% - 290px); // 限制右侧部分的最大宽度，避免文字过长
            // margin-top: 0; // 重置顶部外边距
            padding:15px;
            // 新增样式
            display: flex;
            flex-direction: column;
            height: 250px;

            .name-button-container {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            // 新增样式规则
            .text-title {
                color: #f018aa;
            }
            // 新增样式
            .content-text {
                flex: 1;
                overflow-y: auto;
            }
        }
    }
    .info-container {
        display: flex;
        justify-content: space-around;
        background-color: #fff;
        padding: 15px;
        border-top: 1px dashed #ccc;
        border-bottom: 1px dashed #ccc;
    }
    .custom-button {
        color: #2e7d32; // 设置字体颜色
        border-color: #2e7d32; // 设置边框颜色
        .info {
            // 修改为垂直布局
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
    
            img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                margin-bottom: 10px; // 增加图片下方的间距
            }
    
            h2 {
                margin-bottom: 10px; // 增加标题下方的间距
                margin-left: 0; // 重置左侧外边距
            }
        }
    }
    .content-text {
        background-color: #fff;
        .content-text_content {
            background-color: #fff;
            padding: 15px;
            border-bottom: 1px dashed #ccc;
        }
    }
    .left-align {
        text-align: left;
    }
}
// ... existing code ...
@media (max-width: 768px) {
    .experience {
        .content-section {
            flex-direction: column;
            margin-bottom: 20px;
            
            .left-section {
                width: 100%;
                padding-right: 0;
                margin-bottom: 15px;
                
                h2 {
                    margin-bottom: 10px;
                }
                
                .el-image {
                    width: 100%;
                    height: auto;
                    max-height: 300px;
                }
            }
            
            .right-section {
                max-width: 100%;
                height: auto;
                padding: 0;
                
                .content-text {
                    max-height: none;
                }
            }
        }
        
        .info-container {
            flex-direction: column;
            align-items: center;
            
            .info {
                margin-bottom: 20px;
            }
        }
    }
}
</style>